import { goToLink } from "@actions/common.js";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Content, ExternalWrapper } from "../baseItems";
import Base from "./base";

const BANK_INFO_WRAPPER = styled.div`
	.item {
		display: flex;
		flex-direction: column;
		gap: 5px;
		margin-bottom: 10px;
		font-size: 12px;
		line-height: 14px;
		justify-content: center;
		text-align: center;
		color: #fff;
		.key {
			font-weight: bold;
		}
	}

	.made-deposit-btn {
		display: flex;
		margin: 20px auto;
		background: #fff;
		color: #000;
		border: none;
		padding: 10px 20px;
		border-radius: 5px;
		cursor: pointer;
	}
`;

export class TrendHavale extends Base {
	makeExternalPayment(newStep) {
		const { stake, selectedCurrency } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				type: "havale",
				amount: stake,
				claimsBonus: false,
			},
			(data) => {
				this.setState({
					bankInfo: data,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { iban, stake, selectedCurrency } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				type: "havale",
				amount: stake,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					bankInfo: data,
					currentStep: newStep,
				});
			}
		);
	}

	getStep3(translate) {
		const { bankInfo } = this.state;
		const { goToLink } = this.props;
		return (
			<Content>
				<ExternalWrapper>
					<div>
						{bankInfo && (
							<BANK_INFO_WRAPPER>
								<div className="item">
									<span className="key">{translate("BANK_ACCOUNT_HOLDER")}:</span>
									<span className="value"> {bankInfo.account_holder}</span>
								</div>
								<div className="item">
									<span className="key">{translate("BANK_ACCOUNT_NO")}:</span>
									<span className="value">{bankInfo.account_number}</span>
								</div>
								<div className="item">
									<span className="key">{translate("BANK_NAME")}:</span>
									<span className="value">{bankInfo.bank_name}</span>
								</div>
								{console.log(bankInfo, "bankInfo")}
								{bankInfo?.bank_name && (
									<button
										className="made-deposit-btn"
										onClick={goToLink.bind(this, "/")}>
										{translate("I_HAVE_MADE_THE_DEPOSIT")}
									</button>
								)}
							</BANK_INFO_WRAPPER>
						)}
					</div>
				</ExternalWrapper>
			</Content>
		);
	}
}

const mapDispatchToProps = {
	goToLink,
};

export default connect(null, mapDispatchToProps)(TrendHavale);
